<mat-tab-group mat-stretch-tabs="true">
  <mat-tab label="Sign-In Form">

    <div class="container-fluid p-0 m-0" *ngIf="code && code.site_id; else noSiteForCode">
      <div class="row p-0 m-0">
        <div class="col-12 col-lg-6 p-0 m-0">
          <div class="p-3">
            <h5>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Info</h5>
            <p>{{ code.account.name }}</p>
            <p>{{ code.site.name }}</p>
            <p>{{ code.site.location }}</p>

            <h5>Emergency Evacuation Plan</h5>
            <p>DIAL {{ code.site.emergency_phone || '111' }} FOR FIRE, AMBULANCE, POLICE, GAS, CHEMICAL SPILLS.</p>
            <p>
              <b>
                When you hear the evacuation alarm, switch off all plant and equipment. <br>
                Proceed to the safe assembly point in a calm and orderly fashion by following the exit signs.<br>
                DO NOT take your belongings or use lifts during an evacuation.
              </b>
            </p>
            <p><b>Description of Alarm</b>: {{ code.site.alarm_description || 'A consistent alarm sounding throughout the site or building.' }}</p>
            <p *ngIf="code.site.assembly_location"><b>Assembly Location</b>: {{ code.site.assembly_location }}</p>
            <p *ngIf="code.site.emergency_phone"><b>Emergency Phone</b>: {{ code.site.emergency_phone }}</p>
            <p *ngIf="code.site.hospital_address"><b>Hospital Address</b>: {{ code.site.hospital_address }}</p>
            <p *ngIf="code.site.hospital_phone"><b>Hospital Phone</b>: {{ code.site.hospital_phone }}</p>
            <p *ngIf="code.site.medical_centre_address"><b>Medical Centre Address</b>: {{ code.site.medical_centre_address }}</p>
            <p *ngIf="code.site.medical_centre_phone"><b>Medical Centre Phone</b>: {{ code.site.medical_centre_phone }}</p>
            <p *ngIf="code.site.first_aid_kit_location"><b>First Aid Kit Location</b>: {{ code.site.first_aid_kit_location }}</p>
            <p *ngIf="code.site.aed_location"><b>AED (Automated External Defibrillator) Location</b>: {{ code.site.aed_location }}</p>
            <p *ngIf="code.site.fire_extinguisher_location"><b>Fire Extinguisher Location</b>: {{ code.site.fire_extinguisher_location }}</p>
            <p *ngIf="code.site.worksafe_phone"><b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.worksafe-phone', 'WorkSafe Phone') }}</b>: {{ code.site.worksafe_phone }}</p>
            <p *ngIf="code.site.civil_defence_phone"><b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.civil-defence-phone', 'Civil Defence Phone') }}</b>: {{ code.site.civil_defence_phone }}</p>
            <p *ngIf="code.site.poison_centre_phone"><b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.poison-centre-phone', 'Poison Centre Phone') }}</b>: {{ code.site.poison_centre_phone }}</p>
            <p *ngIf="code.site.power_phone"><b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.power-phone', 'Power (Customer Service) Phone') }}</b>: {{ code.site.power_phone }}</p>
            <p *ngIf="code.site.faults_phone"><b>{{ utils.getLangTerm('sites.emergency-evacuation-plan.labels.faults-phone', '24Hr Faults Phone') }}</b>: {{ code.site.faults_phone }}</p>

            <ng-container *ngIf="['signin:induction', 'signin:all'].indexOf(code.site.site_access_option) > -1">
              <ng-container *ngIf="clearWhiteSpace(code.site.induction_content) != ''">
                <h5>Noticeboard</h5>
                <div [innerHTML]="code.site.induction_content"></div>
              </ng-container>

              <ng-container *ngIf="code.site.hazards.length > 0">
                <h5>Hazards & Risks</h5>
                <ul>
                  <li *ngFor="let hazard of code.site.hazards">{{ hazard.name }}</li>
                </ul>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="code.site.site_access_option == 'signin:all' && code.site.folders.length > 0">
              <h5>Documents</h5>
              <ul>
                <li *ngFor="let folder of code.site.folders">
                  {{ folder.name }}
                  <ul *ngIf="folder.files.length > 0">
                    <li *ngFor="let file of folder.files">
                      <a [href]="file.url" target="_blank">{{ file.name }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </ng-container>

            <hr>
          </div>
        </div>

        <div class="col-12 col-lg-6 p-0 m-0">
          <div class="p-3">
            <p><small>Use the forms below to fill in your company name, email address, full name and mobile number.</small></p>
            <form #signin_f="ngForm" (ngSubmit)="onSignIn(signin_f)" autocomplete="off" data-lpignore="true" data-form-type="other">

              <div class="row">
                <div class="col autocomplete-wrapper">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Company Name</mat-label>
                    <input matInput placeholder="Company Name" [formControl]="companyNameControl" type="text" autocomplete="one-time-code" data-lpignore="true" data-1p-ignore data-form-type="other" (blur)="onFieldBlur('entityNames')" />
                    <mat-hint *ngIf="!(entityNameSearched && autoCompletedEntityNames.length === 0)">Search for your company or employer and select them from the list.</mat-hint>
                    <!-- The empty result is what drives duplicate companies, so it is stated rather than
                         shown as an empty dropdown (SC-2511). Replaces the hint rather than sitting beside
                         it, because this form is used on a phone where vertical room is scarce. -->
                    <mat-hint class="text-warning" *ngIf="entityNameSearched && autoCompletedEntityNames.length === 0">
                      Not found. Check the spelling, or continue and we will confirm before adding it.
                    </mat-hint>
                  </mat-form-field>
                  <div class="autocomplete-dropdown" *ngIf="autoCompletedEntityNames.length > 0">
                    <!-- Near matches are labelled rather than presented as results (SC-2507). -->
                    <div class="autocomplete-option font-weight-bold text-muted" *ngIf="entityNameSuggestionMode">
                      Did you mean...
                    </div>
                    <div class="autocomplete-option" *ngFor="let name of autoCompletedEntityNames" (mousedown)="onSelectEntityName(name)">
                      {{ name }}
                    </div>
                  </div>
                </div>
                <div class="col autocomplete-wrapper">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Email Address</mat-label>
                    <input matInput placeholder="Email Address" [formControl]="signInEmailControl" type="email" autocomplete="one-time-code" data-lpignore="true" data-1p-ignore data-form-type="other" (blur)="onFieldBlur('userEmails')" required email />
                    <mat-hint>Enter your email address here. This field has auto-completion based on past {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} visits</mat-hint>
                  </mat-form-field>
                  <div class="autocomplete-dropdown" *ngIf="autoCompletedUserEmails.length > 0">
                    <div class="autocomplete-option" *ngFor="let email of autoCompletedUserEmails" (mousedown)="onSelectUserEmail(email)">
                      {{ email }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Full Name</mat-label>
                    <input matInput placeholder="Full Name" [(ngModel)]="signInFormData.contact_person" name="contact_person" type="text" autocomplete="one-time-code" data-lpignore="true" data-1p-ignore data-form-type="other" required />
                    <mat-hint>Enter your first and last name here.</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col">
                  <app-phone-input
                    [disableBrowserAutofill]="true"
                    [idInput]="mobile_input_id"
                    [numberInput]="signInFormData.mobile"
                    [countryCodeInput]="signInFormData.mobile_country_code"
                    [dialCodeInput]="signInFormData.mobile_dial_code"
                    [e164NumberInput]="signInFormData.mobile_e164"
                    [additionalClassInput]="'compact'"
                    (phoneDetailsOutput)="getOutputPhoneDetails($event)"
                    [labelInput]="'Mobile Number'"
                    [hintInput]="'Enter your mobile number here.'"
                    required="true">
                  </app-phone-input>
                </div>
              </div>

              <div class="mb-3">
                <mat-checkbox [(ngModel)]="signInFormData.acknowledged" matInput name="acknowledged" required>
                  <span class="text-wrap">
                    I agree to the
                    <a [href]="utils.getTermsAndConditionsUrl()" target="_blank">{{ utils.getAppName() == 'SetConnect' ? 'EULA' : 'Terms & Conditions' }}</a>
                    and
                    <a [href]="utils.getPrivacyPolicyUrl()" target="_blank">Privacy Policy</a> and acknowledge that I understand the emergency evacuation plan outlined above.
                  </span>
                </mat-checkbox>
              </div>

              <div class="d-flex justify-content-center">
                <button type="submit" mat-raised-button [disabled]="!signin_f.valid || inProgress || mobile_error_state" color="primary" class="full-width m-1" style="max-width: 250px">
                  Sign In
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Sign-Out Form">
    <div class="p-3">

      <form #signout_f="ngForm" (ngSubmit)="onSignOut(signout_f)" autocomplete="off" data-lpignore="true" data-form-type="other">

        <div class="row">
          <div class="col-12 col-xl-6">
            <p><small>Use the input below to select your email address. Email address will only show if you are currently signed into the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}.</small></p>

            <div class="autocomplete-wrapper">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Email Address</mat-label>
                <input matInput placeholder="Email Address" [formControl]="signOutEmailControl" type="text" autocomplete="one-time-code" data-lpignore="true" data-1p-ignore data-form-type="other" (blur)="onFieldBlur('onsiteUserEmails')" />
                <mat-hint>Select your email address here. This field has auto-completion based on users signed into the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}.</mat-hint>
              </mat-form-field>
              <div class="autocomplete-dropdown" *ngIf="autoCompletedOnsiteUserEmails.length > 0">
                <div class="autocomplete-option" *ngFor="let email of autoCompletedOnsiteUserEmails" (mousedown)="onSelectOnsiteUserEmail(email)">
                  {{ email }}
                </div>
              </div>
            </div>

            <ng-container *ngIf="signOutFormData.id && signOutFormData.id > 0">
              <h5 class="mt-1">Selected User Details</h5>
              <mat-divider class="w-100 m-0 mb-3" [inset]="true"></mat-divider>

              <h6>Company Name</h6>
              <p>{{ signOutFormData.company_name }}</p>

              <h6>Full Name</h6>
              <p>{{ signOutFormData.contact_person }}</p>

              <h6>Email</h6>
              <p>{{ hideEmail(signOutFormData.email) }}</p>

              <h6>Mobile Number</h6>
              <p>{{ hideMobile(signOutFormData.mobile) }}</p>
            </ng-container>

            <div class="d-flex justify-content-center flex-wrap">
              <button class="full-width m-2" type="submit" mat-raised-button [disabled]="!signout_f.valid || inProgress || signOutFormData.id <= 0" color="primary" style="max-width: 250px">
                Sign Out
              </button>
              <button class="full-width m-2" type="button" mat-raised-button [disabled]="!signout_f.valid || inProgress || signOutFormData.id <= 0" color="secondary" (click)="onClear()" style="max-width: 250px">
                Clear Results
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #noSiteForCode>
  <p>No {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} is associated with this code.</p>
</ng-template>
